module.exports = __webpack_public_path__ + "img/offical.5b27a2f5.jpg";